<template>
  <div class="main-card">
    <div class="dc-heard">
      <div>{{patInfo.NAME}}</div>
      <div>{{patInfo.ApproveDate}}</div>
    </div>

    <div class="dc-items">
      <van-row  v-for="druginfo in drugList" :key="druginfo" @click="appoint(druginfo)">
        <van-col span="8">
          <div class="drug"> {{ druginfo.ITEM_NAME }}</div>
        </van-col>
      </van-row>
    </div>
  </div>

</template>

<script>

import {Toast} from "vant";
import { getQueryString, getLocal} from "@/common/js/utils";
import {customerBussiness, getWxUserInfo} from "@/service/MpServer";
import {AuthWechatShare} from "../../service/MpServer";

export default {
  components: {
  },

  name: 'CusDocList',
  data() {
    return {
      isWinXinClient: false,
      isLoading: false,

      barcode: "",
      patInfo: {},
      drugList: []
    }
  },

  mounted() {
    let app= this;
    let appid = "";

    // 获取当用微信信息
    if (!getQueryString("share")) {   //公众号直接调用
      getWxUserInfo(function () {
        appid = getLocal("login_cus_appid");
        AuthWechatShare(appid, "CusDrugList", "用药明细", "", "", "barCode=" + app.barcode);
        app.Scran();
      });
    }
    else {
      this.barcode = getQueryString("barCode");
      appid= getQueryString("state");

      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri='
        + window.location.href.split('?')[0].replace("#", "%23")
        + '&response_type=code&scope=snsapi_userinfo&state=' + appid + '#wechat_redirect';
      window.location.href = url;
    }
  },

  methods: {
    appoint(docInfo){

    },

    Scran() {
      let _this = this;
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1,                  //默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            _this.barcode = res.resultstr;
            _this.getMedicalInfo(_this.barcode);
          },
          fail: function (response) {
            Toast('wx.scanQRcode失败!' + JSON.stringify(response));
          }
        });
      })
      wx.error(function () {
      });
    },

    getMedicalInfo(barCode) {
      let _this= this;
      let param = { customer: "", barcode: barCode };
      customerBussiness("DRUG_OUTPUT", "getDrugDetail", param, function (data) {
        if ((!JSON.parse(data).Table) || (JSON.parse(data).Table.length== 0)){
          Toast("没有此处方用药信息！");
          return;
        }

        _this.patInfo= JSON.parse(data).Table[0];
        _this.drugList= JSON.parse(data).Table1;
      });
    }
  }
}
</script>

<style lang="less" scoped >
@import '../../common/style/mixin';

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
  font-size: 14px !important;
}

.bt-type{
  margin: 5px 2px 0px 2px;
  height: 28px;
  line-height: 28px;
}

.sc-card{
  min-height: 40px;
  padding: 10px 0px 10px 0px;
  background: rgba(255,255,255,0.65);

  .sc-field{
    background: rgba(255,255,255,0);
  }
  .sc-key{
    border-radius: 20px;
  }
}

.main-card{
  //padding: 15px;
  height: 120px;
  background-image: linear-gradient(180deg, #01BD5D 0%, rgba(40,216,125,0.00) 100%);
}

.dc-heard{
  top: 100px;
  margin-top: 10px;
  background: #FFFFFF;
  font-weight: 600;
}

.dc-items{
  top: 100px;
  margin-top: 10px;
  background: #FFFFFF;
}

.dc-item{
  margin-bottom: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 34px 0 rgba(0,0,0,0.08);
  padding: 5px;
  border-bottom: 2px solid #dedede;
  border-radius: 10px;
  border: 2px solid #dedede;
  height: 80px;

  .dc-image{
    margin: 5px 0px 0px 5px;
    width: 55px;
    height: 55px;
  }
  .docName{
    font-size: 18px;
    line-height: 24px;
    color: #333333;
    //font-family: PingFangSC-Regular;
    //color: #333333;
    //letter-spacing: 0;
    //text-align: center;

  }
  .docTech{
    font-size: 15px;
    line-height: 26px;
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .docDesc{
    line-height: 18px;
    font-size: 14px;
    font-weight: 40;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
  }
}
</style>
